import { getApiConfig } from '@/api/config/client/getApiConfig';
import { EntitlementHeaders } from '@/api/headers';
import { ApiLogger } from '@/api/logger/apiLogger';
import { osDetector } from '@/api/osDetector/client';
import { parseEntitlements } from '@/api/parsers/parseEntitlements';
import type { Entitlements } from '@/api/types/entitlementsTypes';

import { HttpClient, type HttpOptions } from './httpClient';

const apiConfig = getApiConfig();
const { apiKey, isLogEnabled, entitlementBaseUrl } = apiConfig;

/**
 * Entitlements API Client
 * @see https://teamfox.atlassian.net/wiki/spaces/FOXDTC/pages/2359591100/User+Entitlements+API+Spec
 */
export class EntitlementsClient {
  public constructor(private httpClient: HttpClient) {}

  public async getUserEntitlements(options?: HttpOptions): Promise<Entitlements> {
    const response = await this.httpClient.get('/userentitlements/v1/userentitlements', options);

    const entitlements = parseEntitlements(response);

    return entitlements;
  }
}

const logger = new ApiLogger('EntitlementsClient', isLogEnabled);
const headers = new EntitlementHeaders(apiKey);
const httpClient = new HttpClient({ apiConfig, baseUrl: entitlementBaseUrl, logger, headers, osDetector });

export const entitlementsClient = new EntitlementsClient(httpClient);
